import { render } from "./SearchSection.vue?vue&type=template&id=b2ad72f0&scoped=true"
import script from "./SearchSection.vue?vue&type=script&lang=js"
export * from "./SearchSection.vue?vue&type=script&lang=js"

import "./SearchSection.vue?vue&type=style&index=0&id=b2ad72f0&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2ad72f0"]])

export default __exports__